var map = {
	"./custom/app/shared/object-collection/shared/badges/access-status-badge/access-status-badge.component": [
		85553,
		[
			"default-src_app_shared_object-collection_shared_badges_access-status-badge_access-status-badg-04bc50",
			"src_themes_custom_app_shared_object-collection_shared_badges_access-status-badge_access-statu-f5960a"
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 50822;
module.exports = webpackAsyncContext;